import React, { useEffect, useState } from 'react';
import warningIcon from 'images/icons/warning-red.svg';
import Modal, { Footer } from '../../../common/Modal';
import styles from './Navigation.module.scss';

interface ClearWorkModalProps {
  assessmentTitle: string,
  close: () => void;
  error?: boolean;
  isOpen: boolean;
  onSubmit: (e: any) => Promise<any>;
  studentName: string;
  submitting: boolean;
}

const ClearWorkModal = ({
  assessmentTitle,
  close,
  error,
  isOpen,
  onSubmit,
  studentName,
  submitting,
}: ClearWorkModalProps) => {
  const [inputValue, setInputValue] = useState('');

  const resetTextBoxOnModalClose = () => {
    if (!isOpen) setInputValue('');
  };

  useEffect(() => {
    resetTextBoxOnModalClose();
  }, [isOpen]);

  return (
    <Modal
      className="clear-work-modal !tw-border-none"
      closeButtonClassName="tw-text-white hover:tw-text-white"
      closeModal={close}
      error={error}
      headerClass="tw-bg-red tw-text-white"
      headerText="Clear Student Work"
      headerTextClassName="tw-text-white"
      isOpen={isOpen}
    >
      <div className="tw-leading-5">
        You will delete all
        saved <strong>work</strong> and <strong>scores</strong> for {studentName} in <strong>{assessmentTitle}</strong>.
      </div>

      <div className="tw-my-5 tw-flex tw-align-middle tw-h-4">
        <img alt="Warning" className="tw-mr-3" src={warningIcon} />
        Saved work and scores cannot be recovered.
      </div>
      <div>
        Type <strong>DELETE</strong> to confirm:
        <input
          className={styles.textInput}
          type="text"
          value={inputValue}
          onChange={e => setInputValue(e.target.value)}
        />
      </div>
      <form onSubmit={onSubmit}>
        <Footer
          primaryButtonClassName="btn btn--red"
          primaryButtonDisabled={inputValue !== 'DELETE'}
          primaryButtonText="Delete"
          secondaryButtonCallback={close}
          submitting={submitting}
        />
      </form>
    </Modal>
  );
};

export default ClearWorkModal;
